import React from "react";
const VisibleIndentationContext = React.createContext(
  null
);
const VisibleIndentationContextProvider = ({ visibleIndentation, children }) => {
  return /* @__PURE__ */ React.createElement(VisibleIndentationContext.Provider, { value: { visibleIndentation } }, children);
};
export {
  VisibleIndentationContext,
  VisibleIndentationContextProvider
};
//# sourceMappingURL=VisibleIndentationContext.js.map
